"use strict";
/* eslint-disable import/prefer-default-export */
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockCategories = exports.mockTaggingsData = exports.mockTagsData = void 0;
exports.mockTagsData = [
    {
        name: '01',
        displayName: 'January',
        category: 'month',
        uuid: 'e843udjnjweode3ewqhoijwp',
    },
    {
        name: '02',
        displayName: 'February',
        category: 'month',
        uuid: 'e843udjnjweode3ewqhoijw1',
    },
    {
        name: '03',
        displayName: 'March',
        category: 'month',
        uuid: 'e843udjnjweode3ewqhoijw2',
    },
    {
        name: '04',
        displayName: 'April',
        category: 'month',
        uuid: 'e843udjnjweode3ewqhoijw3',
    },
];
exports.mockTaggingsData = {
    total: 60,
    contents: [
        {
            displayName: 'tagging1',
            type: 'lesson',
            uuid: 'entityUuid1',
            categories: 'Programming Languages,Vulnerability',
            tags: [
                {
                    uuid: 'e843udjnjweode3ewqhoijwp',
                    displayName: 'January',
                },
                {
                    uuid: 'e843udjnjweode3ewqhoijw1',
                    displayName: 'February',
                },
            ],
        },
        {
            displayName: 'tagging2',
            type: 'course',
            uuid: 'entityUuid2',
            categories: 'Programming Languages',
            tags: [
                {
                    uuid: 'e843udjnjweode3ewqhoijw2',
                    displayName: 'March',
                },
                {
                    uuid: 'e843udjnjweode3ewqhoijw3',
                    displayName: 'April',
                },
                {
                    uuid: 'e843udjnjweode3ewqhoijwp',
                    displayName: 'January',
                },
                {
                    uuid: 'e843udjnjweode3ewqhoijw2',
                    displayName: 'March',
                },
                {
                    uuid: 'e843udjnjweode3ewqhoijw3',
                    displayName: 'April',
                },
                {
                    uuid: 'e843udjnjweode3ewqhoijwp',
                    displayName: 'January',
                },
                {
                    uuid: 'e843udjnjweode3ewqhoijw2',
                    displayName: 'March',
                },
                {
                    uuid: 'e843udjnjweode3ewqhoijw3',
                    displayName: 'April',
                },
                {
                    uuid: 'e843udjnjweode3ewqhoijwp',
                    displayName: 'January',
                },
                {
                    uuid: 'e843udjnjweode3ewqhoijw2',
                    displayName: 'March',
                },
                {
                    uuid: 'e843udjnjweode3ewqhoijw3',
                    displayName: 'April',
                },
                {
                    uuid: 'e843udjnjweode3ewqhoijwp',
                    displayName: 'January',
                },
                {
                    uuid: 'e843udjnjweode3ewqhoijw2',
                    displayName: 'March',
                },
                {
                    uuid: 'e843udjnjweode3ewqhoijw3',
                    category: 'month',
                    displayName: 'April',
                },
                {
                    uuid: 'e843udjnjweode3ewqhoijwp',
                    displayName: 'January',
                },
            ],
        },
    ],
};
exports.mockCategories = [
    {
        categoryId: 1,
        categoryName: 'Our Picks',
        iconUrl: 'https://content.codebashing.com/courses-assets/ae464616-020a-4521-9b11-89e5120add28.svg',
        isInternal: false,
        tags: [
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijwp',
                displayName: 'Java',
                name: 'java',
                count: 86,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'JavaScript',
                name: 'javascript',
                count: 25,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Angular',
                name: 'angular',
                count: 20,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: '.NET',
                name: 'dotnet',
                count: 71,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Android',
                name: 'android',
                count: 10,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Go',
                name: 'go',
                count: 22,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Node.JS',
                name: 'nodejs',
                count: 27,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'PHP',
                name: 'php',
                count: 54,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Python Django',
                name: 'python',
                count: 63,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Scala',
                name: 'scala',
                count: 46,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Ruby',
                name: 'ruby',
                count: 24,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C/C++',
                name: 'cplus',
                count: 22,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'FrontEnd',
                name: 'frontend',
                count: 6,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'iOS',
                name: 'ios',
                count: 12,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'React',
                name: 'react',
                count: 7,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Perl (client side edition)',
                name: 'perl_client_side_edition',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Perl & Java',
                name: 'perl_java',
                count: 1,
            },
        ],
    },
    {
        categoryId: 2,
        iconUrl: 'https://content.codebashing.com/courses-assets/ae464616-020a-4521-9b11-89e5120add28.svg',
        categoryName: 'Career boosts',
        isInternal: true,
        tags: [
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Cross Site Request Forgery (POST)',
                name: 'csrf_post',
                count: 4,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Cross Site Request Forgery (GET)',
                name: 'csrf_get',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Password Storage',
                name: 'password_storage',
                count: 7,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Authentication Credentials In Url',
                name: 'authentication_credentials_in_url',
                count: 16,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Insecure Tls Validation',
                name: 'insecure_tls_validation',
                count: 13,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Xxe Injection',
                name: 'xxe_injection',
                count: 4,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Click Jacking',
                name: 'click_jacking',
                count: 12,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Insecure Url Redirect',
                name: 'insecure_url_redirect',
                count: 9,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Use Of Insufficiently Random Values',
                name: 'use_of_insufficiently_random_values',
                count: 16,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Ldap Injection',
                name: 'ldap_injection',
                count: 10,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Http Response Splitting',
                name: 'http_response_splitting',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Dom Open Redirect',
                name: 'dom_open_redirect',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Web Cache Deception',
                name: 'web_cache_deception',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Reverse Tabnabbing',
                name: 'reverse_tabnabbing',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Autocomplete',
                name: 'autocomplete',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Excessive Logging',
                name: 'excessive_logging',
                count: 5,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Cross Site Request Forgery Get',
                name: 'cross_site_request_forgery_get',
                count: 4,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Cross Site Request Forgery Post',
                name: 'cross_site_request_forgery_post',
                count: 16,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Heap P3',
                name: 'c_heap_p3',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Heap P2',
                name: 'c_heap_p2',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Insecure Data Storage Plist',
                name: 'insecure_data_storage_plist',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Insecure Data Storage File',
                name: 'insecure_data_storage_file',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Insecure Data Storage',
                name: 'insecure_data_storage',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Sandbox Introduction',
                name: 'sandbox_introduction',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Anti Xss Mechanism Url Sanitaizer',
                name: 'anti_xss_mechanism_url_sanitaizer',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Anti Xss Mechanism Html Sanitaizer',
                name: 'anti_xss_mechanism_html_sanitaizer',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Path Traversal',
                name: 'path_traversal',
                count: 4,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Server Side Request Forgery',
                name: 'server_side_request_forgery',
                count: 10,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Sensitive Data Exposure',
                name: 'sensitive_data_exposure',
                count: 4,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Broken Authentication',
                name: 'broken_authentication',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Security Misconfigurations',
                name: 'security_misconfigurations',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Injection Flaws',
                name: 'injection_flaws',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Broken Access Control',
                name: 'broken_access_control',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Reflected Xss',
                name: 'reflected_xss',
                count: 15,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Stored Xss',
                name: 'stored_xss',
                count: 6,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Xxe Processing',
                name: 'xxe_processing',
                count: 18,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Directory Path Traversal',
                name: 'directory_path_traversal',
                count: 16,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Forceful Browsing',
                name: 'forceful_browsing',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Components With Known Vulnerabilities',
                name: 'components_with_known_vulnerabilities',
                count: 17,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Cached Login Credentials',
                name: 'cached_login_credentials',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Unprotected Background Screenshots',
                name: 'unprotected_background_screenshots',
                count: 4,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Sql Injection',
                name: 'sql_injection',
                count: 19,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Command Injection',
                name: 'command_injection',
                count: 19,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Second Order Sql Injection',
                name: 'second_order_sql_injection',
                count: 10,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Session Fixation',
                name: 'session_fixation',
                count: 13,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Session Exposure Within Url',
                name: 'session_exposure_within_url',
                count: 10,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Horizontal Privilege Escalation',
                name: 'horizontal_privilege_escalation',
                count: 17,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Vertical Privilege Escalation',
                name: 'vertical_privilege_escalation',
                count: 17,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Race Condition',
                name: 'race_condition',
                count: 9,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Unrestricted File Upload',
                name: 'unrestricted_file_upload',
                count: 4,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Privileged Interface Exposure',
                name: 'privileged_interface_exposure',
                count: 10,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Leftover Debug Code',
                name: 'leftover_debug_code',
                count: 15,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'User Enumeration',
                name: 'user_enumeration',
                count: 17,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Dom Xss',
                name: 'dom_xss',
                count: 9,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Insecure Object Deserialization',
                name: 'insecure_object_deserialization',
                count: 17,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Client Side Injection',
                name: 'client_side_injection',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Insecure Password Storage',
                name: 'insecure_password_storage',
                count: 4,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Server Side Request Forgery Ssrf',
                name: 'server_side_request_forgery_ssrf',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Mozilla Bleach Mutation Cross Site Scripting Mxss',
                name: 'mozilla_bleach_mutation_cross_site_scripting_mxss',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Apache Unomi',
                name: 'apache_unomi',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Flask Panel Xss',
                name: 'flask_panel_xss',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Vertx Xxe',
                name: 'vertx_xxe',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Common Xss Usecases',
                name: 'common_xss_usecases',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Dom Xss Eval',
                name: 'dom_xss_eval',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Dom Xss Ajax',
                name: 'dom_xss_ajax',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'The Dangerouslysetinnerhtml Property',
                name: 'the_dangerouslysetinnerhtml_property',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Cross Site Scripting In React',
                name: 'cross_site_scripting_in_react',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Insufficient Logging And Monitoring',
                name: 'insufficient_logging_and_monitoring',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Open Redirect',
                name: 'open_redirect',
                count: 4,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Using Components With Known Vulnerabilities',
                name: 'using_components_with_known_vulnerabilities',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Broken Function Level Authorization',
                name: 'broken_function_level_authorization',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Broken Object Level Authorization',
                name: 'broken_object_level_authorization',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Templates From Untrusted Sources',
                name: 'templates_from_untrusted_sources',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Html And Url Sanitizers',
                name: 'html_and_url_sanitizers',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Strict Contextual Escaping',
                name: 'strict_contextual_escaping',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Sandbox Escaping Scenarios',
                name: 'sandbox_escaping_scenarios',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'No Server Side Validation',
                name: 'no_server_side_validation',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Sensitive Data In Code',
                name: 'sensitive_data_in_code',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Xss Protection Bypass',
                name: 'xss_protection_bypass',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Cross Site Request Forgery',
                name: 'cross_site_request_forgery',
                count: 10,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Mind The Pipe Part 1',
                name: 'mind_the_pipe_part_1',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Stored Persistent Xss',
                name: 'stored_persistent_xss',
                count: 10,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Race Conditions P1',
                name: 'race_conditions_p1',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Null Pointer Dereference P1',
                name: 'null_pointer_dereference_p1',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Compiler Optimizations Bugs P1',
                name: 'compiler_optimizations_bugs_p1',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Dangerous Use Of Api P1',
                name: 'dangerous_use_of_api_p1',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Clearing Memory P1',
                name: 'clearing_memory_p1',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Formatstring P3',
                name: 'c_formatstring_p3',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Formatstring P2',
                name: 'c_formatstring_p2',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Formatstring P1',
                name: 'c_formatstring_p1',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Integer P1',
                name: 'c_integer_p1',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Heap P1',
                name: 'c_heap_p1',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Stack P3',
                name: 'c_stack_p3',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Stack P2',
                name: 'c_stack_p2',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Orientation',
                name: 'c_orientation',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Stack P1',
                name: 'c_stack_p1',
                count: 1,
            },
        ],
    },
    {
        categoryId: 3,
        iconUrl: 'https://content.codebashing.com/courses-assets/ae464616-020a-4521-9b11-89e5120add28.svg',
        categoryName: 'Who are you',
        isInternal: true,
        tags: [
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Cross Site Request Forgery (POST)',
                name: 'csrf_post',
                count: 4,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Cross Site Request Forgery (GET)',
                name: 'csrf_get',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Password Storage',
                name: 'password_storage',
                count: 7,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Authentication Credentials In Url',
                name: 'authentication_credentials_in_url',
                count: 16,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Insecure Tls Validation',
                name: 'insecure_tls_validation',
                count: 13,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Xxe Injection',
                name: 'xxe_injection',
                count: 4,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Click Jacking',
                name: 'click_jacking',
                count: 12,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Insecure Url Redirect',
                name: 'insecure_url_redirect',
                count: 9,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Use Of Insufficiently Random Values',
                name: 'use_of_insufficiently_random_values',
                count: 16,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Ldap Injection',
                name: 'ldap_injection',
                count: 10,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Http Response Splitting',
                name: 'http_response_splitting',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Dom Open Redirect',
                name: 'dom_open_redirect',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Web Cache Deception',
                name: 'web_cache_deception',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Reverse Tabnabbing',
                name: 'reverse_tabnabbing',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Autocomplete',
                name: 'autocomplete',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Excessive Logging',
                name: 'excessive_logging',
                count: 5,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Cross Site Request Forgery Get',
                name: 'cross_site_request_forgery_get',
                count: 4,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Cross Site Request Forgery Post',
                name: 'cross_site_request_forgery_post',
                count: 16,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Heap P3',
                name: 'c_heap_p3',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Heap P2',
                name: 'c_heap_p2',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Insecure Data Storage Plist',
                name: 'insecure_data_storage_plist',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Insecure Data Storage File',
                name: 'insecure_data_storage_file',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Insecure Data Storage',
                name: 'insecure_data_storage',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Sandbox Introduction',
                name: 'sandbox_introduction',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Anti Xss Mechanism Url Sanitaizer',
                name: 'anti_xss_mechanism_url_sanitaizer',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Anti Xss Mechanism Html Sanitaizer',
                name: 'anti_xss_mechanism_html_sanitaizer',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Path Traversal',
                name: 'path_traversal',
                count: 4,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Server Side Request Forgery',
                name: 'server_side_request_forgery',
                count: 10,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Sensitive Data Exposure',
                name: 'sensitive_data_exposure',
                count: 4,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Broken Authentication',
                name: 'broken_authentication',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Security Misconfigurations',
                name: 'security_misconfigurations',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Injection Flaws',
                name: 'injection_flaws',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Broken Access Control',
                name: 'broken_access_control',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Reflected Xss',
                name: 'reflected_xss',
                count: 15,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Stored Xss',
                name: 'stored_xss',
                count: 6,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Xxe Processing',
                name: 'xxe_processing',
                count: 18,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Directory Path Traversal',
                name: 'directory_path_traversal',
                count: 16,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Forceful Browsing',
                name: 'forceful_browsing',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Components With Known Vulnerabilities',
                name: 'components_with_known_vulnerabilities',
                count: 17,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Cached Login Credentials',
                name: 'cached_login_credentials',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Unprotected Background Screenshots',
                name: 'unprotected_background_screenshots',
                count: 4,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Sql Injection',
                name: 'sql_injection',
                count: 19,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Command Injection',
                name: 'command_injection',
                count: 19,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Second Order Sql Injection',
                name: 'second_order_sql_injection',
                count: 10,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Session Fixation',
                name: 'session_fixation',
                count: 13,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Session Exposure Within Url',
                name: 'session_exposure_within_url',
                count: 10,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Horizontal Privilege Escalation',
                name: 'horizontal_privilege_escalation',
                count: 17,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Vertical Privilege Escalation',
                name: 'vertical_privilege_escalation',
                count: 17,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Race Condition',
                name: 'race_condition',
                count: 9,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Unrestricted File Upload',
                name: 'unrestricted_file_upload',
                count: 4,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Privileged Interface Exposure',
                name: 'privileged_interface_exposure',
                count: 10,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Leftover Debug Code',
                name: 'leftover_debug_code',
                count: 15,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'User Enumeration',
                name: 'user_enumeration',
                count: 17,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Dom Xss',
                name: 'dom_xss',
                count: 9,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Insecure Object Deserialization',
                name: 'insecure_object_deserialization',
                count: 17,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Client Side Injection',
                name: 'client_side_injection',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Insecure Password Storage',
                name: 'insecure_password_storage',
                count: 4,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Server Side Request Forgery Ssrf',
                name: 'server_side_request_forgery_ssrf',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Mozilla Bleach Mutation Cross Site Scripting Mxss',
                name: 'mozilla_bleach_mutation_cross_site_scripting_mxss',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Apache Unomi',
                name: 'apache_unomi',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Flask Panel Xss',
                name: 'flask_panel_xss',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Vertx Xxe',
                name: 'vertx_xxe',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Common Xss Usecases',
                name: 'common_xss_usecases',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Dom Xss Eval',
                name: 'dom_xss_eval',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Dom Xss Ajax',
                name: 'dom_xss_ajax',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'The Dangerouslysetinnerhtml Property',
                name: 'the_dangerouslysetinnerhtml_property',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Cross Site Scripting In React',
                name: 'cross_site_scripting_in_react',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Insufficient Logging And Monitoring',
                name: 'insufficient_logging_and_monitoring',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Open Redirect',
                name: 'open_redirect',
                count: 4,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Using Components With Known Vulnerabilities',
                name: 'using_components_with_known_vulnerabilities',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Broken Function Level Authorization',
                name: 'broken_function_level_authorization',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Broken Object Level Authorization',
                name: 'broken_object_level_authorization',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Templates From Untrusted Sources',
                name: 'templates_from_untrusted_sources',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Html And Url Sanitizers',
                name: 'html_and_url_sanitizers',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Strict Contextual Escaping',
                name: 'strict_contextual_escaping',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Sandbox Escaping Scenarios',
                name: 'sandbox_escaping_scenarios',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'No Server Side Validation',
                name: 'no_server_side_validation',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Sensitive Data In Code',
                name: 'sensitive_data_in_code',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Xss Protection Bypass',
                name: 'xss_protection_bypass',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Cross Site Request Forgery',
                name: 'cross_site_request_forgery',
                count: 10,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Mind The Pipe Part 1',
                name: 'mind_the_pipe_part_1',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Stored Persistent Xss',
                name: 'stored_persistent_xss',
                count: 10,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Race Conditions P1',
                name: 'race_conditions_p1',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Null Pointer Dereference P1',
                name: 'null_pointer_dereference_p1',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Compiler Optimizations Bugs P1',
                name: 'compiler_optimizations_bugs_p1',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Dangerous Use Of Api P1',
                name: 'dangerous_use_of_api_p1',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Clearing Memory P1',
                name: 'clearing_memory_p1',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Formatstring P3',
                name: 'c_formatstring_p3',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Formatstring P2',
                name: 'c_formatstring_p2',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Formatstring P1',
                name: 'c_formatstring_p1',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Integer P1',
                name: 'c_integer_p1',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Heap P1',
                name: 'c_heap_p1',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Stack P3',
                name: 'c_stack_p3',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Stack P2',
                name: 'c_stack_p2',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Orientation',
                name: 'c_orientation',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Stack P1',
                name: 'c_stack_p1',
                count: 1,
            },
        ],
    },
    {
        categoryId: 4,
        iconUrl: 'https://content.codebashing.com/courses-assets/ae464616-020a-4521-9b11-89e5120add28.svg',
        categoryName: 'Languages',
        isInternal: true,
        tags: [
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Cross Site Request Forgery (POST)',
                name: 'csrf_post',
                count: 4,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Cross Site Request Forgery (GET)',
                name: 'csrf_get',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Password Storage',
                name: 'password_storage',
                count: 7,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Authentication Credentials In Url',
                name: 'authentication_credentials_in_url',
                count: 16,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Insecure Tls Validation',
                name: 'insecure_tls_validation',
                count: 13,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Xxe Injection',
                name: 'xxe_injection',
                count: 4,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Click Jacking',
                name: 'click_jacking',
                count: 12,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Insecure Url Redirect',
                name: 'insecure_url_redirect',
                count: 9,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Use Of Insufficiently Random Values',
                name: 'use_of_insufficiently_random_values',
                count: 16,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Ldap Injection',
                name: 'ldap_injection',
                count: 10,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Http Response Splitting',
                name: 'http_response_splitting',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Dom Open Redirect',
                name: 'dom_open_redirect',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Web Cache Deception',
                name: 'web_cache_deception',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Reverse Tabnabbing',
                name: 'reverse_tabnabbing',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Autocomplete',
                name: 'autocomplete',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Excessive Logging',
                name: 'excessive_logging',
                count: 5,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Cross Site Request Forgery Get',
                name: 'cross_site_request_forgery_get',
                count: 4,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Cross Site Request Forgery Post',
                name: 'cross_site_request_forgery_post',
                count: 16,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Heap P3',
                name: 'c_heap_p3',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Heap P2',
                name: 'c_heap_p2',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Insecure Data Storage Plist',
                name: 'insecure_data_storage_plist',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Insecure Data Storage File',
                name: 'insecure_data_storage_file',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Insecure Data Storage',
                name: 'insecure_data_storage',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Sandbox Introduction',
                name: 'sandbox_introduction',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Anti Xss Mechanism Url Sanitaizer',
                name: 'anti_xss_mechanism_url_sanitaizer',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Anti Xss Mechanism Html Sanitaizer',
                name: 'anti_xss_mechanism_html_sanitaizer',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Path Traversal',
                name: 'path_traversal',
                count: 4,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Server Side Request Forgery',
                name: 'server_side_request_forgery',
                count: 10,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Sensitive Data Exposure',
                name: 'sensitive_data_exposure',
                count: 4,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Broken Authentication',
                name: 'broken_authentication',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Security Misconfigurations',
                name: 'security_misconfigurations',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Injection Flaws',
                name: 'injection_flaws',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Broken Access Control',
                name: 'broken_access_control',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Reflected Xss',
                name: 'reflected_xss',
                count: 15,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Stored Xss',
                name: 'stored_xss',
                count: 6,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Xxe Processing',
                name: 'xxe_processing',
                count: 18,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Directory Path Traversal',
                name: 'directory_path_traversal',
                count: 16,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Forceful Browsing',
                name: 'forceful_browsing',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Components With Known Vulnerabilities',
                name: 'components_with_known_vulnerabilities',
                count: 17,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Cached Login Credentials',
                name: 'cached_login_credentials',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Unprotected Background Screenshots',
                name: 'unprotected_background_screenshots',
                count: 4,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Sql Injection',
                name: 'sql_injection',
                count: 19,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Command Injection',
                name: 'command_injection',
                count: 19,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Second Order Sql Injection',
                name: 'second_order_sql_injection',
                count: 10,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Session Fixation',
                name: 'session_fixation',
                count: 13,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Session Exposure Within Url',
                name: 'session_exposure_within_url',
                count: 10,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Horizontal Privilege Escalation',
                name: 'horizontal_privilege_escalation',
                count: 17,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Vertical Privilege Escalation',
                name: 'vertical_privilege_escalation',
                count: 17,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Race Condition',
                name: 'race_condition',
                count: 9,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Unrestricted File Upload',
                name: 'unrestricted_file_upload',
                count: 4,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Privileged Interface Exposure',
                name: 'privileged_interface_exposure',
                count: 10,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Leftover Debug Code',
                name: 'leftover_debug_code',
                count: 15,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'User Enumeration',
                name: 'user_enumeration',
                count: 17,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Dom Xss',
                name: 'dom_xss',
                count: 9,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Insecure Object Deserialization',
                name: 'insecure_object_deserialization',
                count: 17,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Client Side Injection',
                name: 'client_side_injection',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Insecure Password Storage',
                name: 'insecure_password_storage',
                count: 4,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Server Side Request Forgery Ssrf',
                name: 'server_side_request_forgery_ssrf',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Mozilla Bleach Mutation Cross Site Scripting Mxss',
                name: 'mozilla_bleach_mutation_cross_site_scripting_mxss',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Apache Unomi',
                name: 'apache_unomi',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Flask Panel Xss',
                name: 'flask_panel_xss',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Vertx Xxe',
                name: 'vertx_xxe',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Common Xss Usecases',
                name: 'common_xss_usecases',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Dom Xss Eval',
                name: 'dom_xss_eval',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Dom Xss Ajax',
                name: 'dom_xss_ajax',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'The Dangerouslysetinnerhtml Property',
                name: 'the_dangerouslysetinnerhtml_property',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Cross Site Scripting In React',
                name: 'cross_site_scripting_in_react',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Insufficient Logging And Monitoring',
                name: 'insufficient_logging_and_monitoring',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Open Redirect',
                name: 'open_redirect',
                count: 4,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Using Components With Known Vulnerabilities',
                name: 'using_components_with_known_vulnerabilities',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Broken Function Level Authorization',
                name: 'broken_function_level_authorization',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Broken Object Level Authorization',
                name: 'broken_object_level_authorization',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Templates From Untrusted Sources',
                name: 'templates_from_untrusted_sources',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Html And Url Sanitizers',
                name: 'html_and_url_sanitizers',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Strict Contextual Escaping',
                name: 'strict_contextual_escaping',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Sandbox Escaping Scenarios',
                name: 'sandbox_escaping_scenarios',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'No Server Side Validation',
                name: 'no_server_side_validation',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Sensitive Data In Code',
                name: 'sensitive_data_in_code',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Xss Protection Bypass',
                name: 'xss_protection_bypass',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Cross Site Request Forgery',
                name: 'cross_site_request_forgery',
                count: 10,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Mind The Pipe Part 1',
                name: 'mind_the_pipe_part_1',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Stored Persistent Xss',
                name: 'stored_persistent_xss',
                count: 10,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Race Conditions P1',
                name: 'race_conditions_p1',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Null Pointer Dereference P1',
                name: 'null_pointer_dereference_p1',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Compiler Optimizations Bugs P1',
                name: 'compiler_optimizations_bugs_p1',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Dangerous Use Of Api P1',
                name: 'dangerous_use_of_api_p1',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Clearing Memory P1',
                name: 'clearing_memory_p1',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Formatstring P3',
                name: 'c_formatstring_p3',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Formatstring P2',
                name: 'c_formatstring_p2',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Formatstring P1',
                name: 'c_formatstring_p1',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Integer P1',
                name: 'c_integer_p1',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Heap P1',
                name: 'c_heap_p1',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Stack P3',
                name: 'c_stack_p3',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Stack P2',
                name: 'c_stack_p2',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Orientation',
                name: 'c_orientation',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Stack P1',
                name: 'c_stack_p1',
                count: 1,
            },
        ],
    },
    {
        categoryId: 5,
        iconUrl: 'https://content.codebashing.com/courses-assets/ae464616-020a-4521-9b11-89e5120add28.svg',
        categoryName: 'Vulnerabilities',
        isInternal: true,
        tags: [
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Cross Site Request Forgery (POST)',
                name: 'csrf_post',
                count: 4,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Cross Site Request Forgery (GET)',
                name: 'csrf_get',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Password Storage',
                name: 'password_storage',
                count: 7,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Authentication Credentials In Url',
                name: 'authentication_credentials_in_url',
                count: 16,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Insecure Tls Validation',
                name: 'insecure_tls_validation',
                count: 13,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Xxe Injection',
                name: 'xxe_injection',
                count: 4,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Click Jacking',
                name: 'click_jacking',
                count: 12,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Insecure Url Redirect',
                name: 'insecure_url_redirect',
                count: 9,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Use Of Insufficiently Random Values',
                name: 'use_of_insufficiently_random_values',
                count: 16,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Ldap Injection',
                name: 'ldap_injection',
                count: 10,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Http Response Splitting',
                name: 'http_response_splitting',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Dom Open Redirect',
                name: 'dom_open_redirect',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Web Cache Deception',
                name: 'web_cache_deception',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Reverse Tabnabbing',
                name: 'reverse_tabnabbing',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Autocomplete',
                name: 'autocomplete',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Excessive Logging',
                name: 'excessive_logging',
                count: 5,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Cross Site Request Forgery Get',
                name: 'cross_site_request_forgery_get',
                count: 4,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Cross Site Request Forgery Post',
                name: 'cross_site_request_forgery_post',
                count: 16,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Heap P3',
                name: 'c_heap_p3',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Heap P2',
                name: 'c_heap_p2',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Insecure Data Storage Plist',
                name: 'insecure_data_storage_plist',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Insecure Data Storage File',
                name: 'insecure_data_storage_file',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Insecure Data Storage',
                name: 'insecure_data_storage',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Sandbox Introduction',
                name: 'sandbox_introduction',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Anti Xss Mechanism Url Sanitaizer',
                name: 'anti_xss_mechanism_url_sanitaizer',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Anti Xss Mechanism Html Sanitaizer',
                name: 'anti_xss_mechanism_html_sanitaizer',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Path Traversal',
                name: 'path_traversal',
                count: 4,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Server Side Request Forgery',
                name: 'server_side_request_forgery',
                count: 10,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Sensitive Data Exposure',
                name: 'sensitive_data_exposure',
                count: 4,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Broken Authentication',
                name: 'broken_authentication',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Security Misconfigurations',
                name: 'security_misconfigurations',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Injection Flaws',
                name: 'injection_flaws',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Broken Access Control',
                name: 'broken_access_control',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Reflected Xss',
                name: 'reflected_xss',
                count: 15,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Stored Xss',
                name: 'stored_xss',
                count: 6,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Xxe Processing',
                name: 'xxe_processing',
                count: 18,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Directory Path Traversal',
                name: 'directory_path_traversal',
                count: 16,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Forceful Browsing',
                name: 'forceful_browsing',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Components With Known Vulnerabilities',
                name: 'components_with_known_vulnerabilities',
                count: 17,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Cached Login Credentials',
                name: 'cached_login_credentials',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Unprotected Background Screenshots',
                name: 'unprotected_background_screenshots',
                count: 4,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Sql Injection',
                name: 'sql_injection',
                count: 19,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Command Injection',
                name: 'command_injection',
                count: 19,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Second Order Sql Injection',
                name: 'second_order_sql_injection',
                count: 10,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Session Fixation',
                name: 'session_fixation',
                count: 13,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Session Exposure Within Url',
                name: 'session_exposure_within_url',
                count: 10,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Horizontal Privilege Escalation',
                name: 'horizontal_privilege_escalation',
                count: 17,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Vertical Privilege Escalation',
                name: 'vertical_privilege_escalation',
                count: 17,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Race Condition',
                name: 'race_condition',
                count: 9,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Unrestricted File Upload',
                name: 'unrestricted_file_upload',
                count: 4,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Privileged Interface Exposure',
                name: 'privileged_interface_exposure',
                count: 10,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Leftover Debug Code',
                name: 'leftover_debug_code',
                count: 15,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'User Enumeration',
                name: 'user_enumeration',
                count: 17,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Dom Xss',
                name: 'dom_xss',
                count: 9,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Insecure Object Deserialization',
                name: 'insecure_object_deserialization',
                count: 17,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Client Side Injection',
                name: 'client_side_injection',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Insecure Password Storage',
                name: 'insecure_password_storage',
                count: 4,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Server Side Request Forgery Ssrf',
                name: 'server_side_request_forgery_ssrf',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Mozilla Bleach Mutation Cross Site Scripting Mxss',
                name: 'mozilla_bleach_mutation_cross_site_scripting_mxss',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Apache Unomi',
                name: 'apache_unomi',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Flask Panel Xss',
                name: 'flask_panel_xss',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Vertx Xxe',
                name: 'vertx_xxe',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Common Xss Usecases',
                name: 'common_xss_usecases',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Dom Xss Eval',
                name: 'dom_xss_eval',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Dom Xss Ajax',
                name: 'dom_xss_ajax',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'The Dangerouslysetinnerhtml Property',
                name: 'the_dangerouslysetinnerhtml_property',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Cross Site Scripting In React',
                name: 'cross_site_scripting_in_react',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Insufficient Logging And Monitoring',
                name: 'insufficient_logging_and_monitoring',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Open Redirect',
                name: 'open_redirect',
                count: 4,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Using Components With Known Vulnerabilities',
                name: 'using_components_with_known_vulnerabilities',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Broken Function Level Authorization',
                name: 'broken_function_level_authorization',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Broken Object Level Authorization',
                name: 'broken_object_level_authorization',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Templates From Untrusted Sources',
                name: 'templates_from_untrusted_sources',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Html And Url Sanitizers',
                name: 'html_and_url_sanitizers',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Strict Contextual Escaping',
                name: 'strict_contextual_escaping',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Sandbox Escaping Scenarios',
                name: 'sandbox_escaping_scenarios',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'No Server Side Validation',
                name: 'no_server_side_validation',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Sensitive Data In Code',
                name: 'sensitive_data_in_code',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Xss Protection Bypass',
                name: 'xss_protection_bypass',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Cross Site Request Forgery',
                name: 'cross_site_request_forgery',
                count: 10,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Mind The Pipe Part 1',
                name: 'mind_the_pipe_part_1',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Stored Persistent Xss',
                name: 'stored_persistent_xss',
                count: 10,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Race Conditions P1',
                name: 'race_conditions_p1',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Null Pointer Dereference P1',
                name: 'null_pointer_dereference_p1',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Compiler Optimizations Bugs P1',
                name: 'compiler_optimizations_bugs_p1',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Dangerous Use Of Api P1',
                name: 'dangerous_use_of_api_p1',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Clearing Memory P1',
                name: 'clearing_memory_p1',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Formatstring P3',
                name: 'c_formatstring_p3',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Formatstring P2',
                name: 'c_formatstring_p2',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Formatstring P1',
                name: 'c_formatstring_p1',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Integer P1',
                name: 'c_integer_p1',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Heap P1',
                name: 'c_heap_p1',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Stack P3',
                name: 'c_stack_p3',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Stack P2',
                name: 'c_stack_p2',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Orientation',
                name: 'c_orientation',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Stack P1',
                name: 'c_stack_p1',
                count: 1,
            },
        ],
    },
    {
        categoryId: 6,
        iconUrl: 'https://content.codebashing.com/courses-assets/ae464616-020a-4521-9b11-89e5120add28.svg',
        categoryName: 'OWASP',
        isInternal: true,
        tags: [
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Cross Site Request Forgery (POST)',
                name: 'csrf_post',
                count: 4,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Cross Site Request Forgery (GET)',
                name: 'csrf_get',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Password Storage',
                name: 'password_storage',
                count: 7,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Authentication Credentials In Url',
                name: 'authentication_credentials_in_url',
                count: 16,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Insecure Tls Validation',
                name: 'insecure_tls_validation',
                count: 13,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Xxe Injection',
                name: 'xxe_injection',
                count: 4,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Click Jacking',
                name: 'click_jacking',
                count: 12,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Insecure Url Redirect',
                name: 'insecure_url_redirect',
                count: 9,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Use Of Insufficiently Random Values',
                name: 'use_of_insufficiently_random_values',
                count: 16,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Ldap Injection',
                name: 'ldap_injection',
                count: 10,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Http Response Splitting',
                name: 'http_response_splitting',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Dom Open Redirect',
                name: 'dom_open_redirect',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Web Cache Deception',
                name: 'web_cache_deception',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Reverse Tabnabbing',
                name: 'reverse_tabnabbing',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Autocomplete',
                name: 'autocomplete',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Excessive Logging',
                name: 'excessive_logging',
                count: 5,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Cross Site Request Forgery Get',
                name: 'cross_site_request_forgery_get',
                count: 4,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Cross Site Request Forgery Post',
                name: 'cross_site_request_forgery_post',
                count: 16,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Heap P3',
                name: 'c_heap_p3',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Heap P2',
                name: 'c_heap_p2',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Insecure Data Storage Plist',
                name: 'insecure_data_storage_plist',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Insecure Data Storage File',
                name: 'insecure_data_storage_file',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Insecure Data Storage',
                name: 'insecure_data_storage',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Sandbox Introduction',
                name: 'sandbox_introduction',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Anti Xss Mechanism Url Sanitaizer',
                name: 'anti_xss_mechanism_url_sanitaizer',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Anti Xss Mechanism Html Sanitaizer',
                name: 'anti_xss_mechanism_html_sanitaizer',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Path Traversal',
                name: 'path_traversal',
                count: 4,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Server Side Request Forgery',
                name: 'server_side_request_forgery',
                count: 10,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Sensitive Data Exposure',
                name: 'sensitive_data_exposure',
                count: 4,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Broken Authentication',
                name: 'broken_authentication',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Security Misconfigurations',
                name: 'security_misconfigurations',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Injection Flaws',
                name: 'injection_flaws',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Broken Access Control',
                name: 'broken_access_control',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Reflected Xss',
                name: 'reflected_xss',
                count: 15,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Stored Xss',
                name: 'stored_xss',
                count: 6,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Xxe Processing',
                name: 'xxe_processing',
                count: 18,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Directory Path Traversal',
                name: 'directory_path_traversal',
                count: 16,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Forceful Browsing',
                name: 'forceful_browsing',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Components With Known Vulnerabilities',
                name: 'components_with_known_vulnerabilities',
                count: 17,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Cached Login Credentials',
                name: 'cached_login_credentials',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Unprotected Background Screenshots',
                name: 'unprotected_background_screenshots',
                count: 4,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Sql Injection',
                name: 'sql_injection',
                count: 19,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Command Injection',
                name: 'command_injection',
                count: 19,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Second Order Sql Injection',
                name: 'second_order_sql_injection',
                count: 10,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Session Fixation',
                name: 'session_fixation',
                count: 13,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Session Exposure Within Url',
                name: 'session_exposure_within_url',
                count: 10,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Horizontal Privilege Escalation',
                name: 'horizontal_privilege_escalation',
                count: 17,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Vertical Privilege Escalation',
                name: 'vertical_privilege_escalation',
                count: 17,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Race Condition',
                name: 'race_condition',
                count: 9,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Unrestricted File Upload',
                name: 'unrestricted_file_upload',
                count: 4,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Privileged Interface Exposure',
                name: 'privileged_interface_exposure',
                count: 10,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Leftover Debug Code',
                name: 'leftover_debug_code',
                count: 15,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'User Enumeration',
                name: 'user_enumeration',
                count: 17,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Dom Xss',
                name: 'dom_xss',
                count: 9,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Insecure Object Deserialization',
                name: 'insecure_object_deserialization',
                count: 17,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Client Side Injection',
                name: 'client_side_injection',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Insecure Password Storage',
                name: 'insecure_password_storage',
                count: 4,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Server Side Request Forgery Ssrf',
                name: 'server_side_request_forgery_ssrf',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Mozilla Bleach Mutation Cross Site Scripting Mxss',
                name: 'mozilla_bleach_mutation_cross_site_scripting_mxss',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Apache Unomi',
                name: 'apache_unomi',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Flask Panel Xss',
                name: 'flask_panel_xss',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Vertx Xxe',
                name: 'vertx_xxe',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Common Xss Usecases',
                name: 'common_xss_usecases',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Dom Xss Eval',
                name: 'dom_xss_eval',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Dom Xss Ajax',
                name: 'dom_xss_ajax',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'The Dangerouslysetinnerhtml Property',
                name: 'the_dangerouslysetinnerhtml_property',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Cross Site Scripting In React',
                name: 'cross_site_scripting_in_react',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Insufficient Logging And Monitoring',
                name: 'insufficient_logging_and_monitoring',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Open Redirect',
                name: 'open_redirect',
                count: 4,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Using Components With Known Vulnerabilities',
                name: 'using_components_with_known_vulnerabilities',
                count: 3,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Broken Function Level Authorization',
                name: 'broken_function_level_authorization',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Broken Object Level Authorization',
                name: 'broken_object_level_authorization',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Templates From Untrusted Sources',
                name: 'templates_from_untrusted_sources',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Html And Url Sanitizers',
                name: 'html_and_url_sanitizers',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Strict Contextual Escaping',
                name: 'strict_contextual_escaping',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Sandbox Escaping Scenarios',
                name: 'sandbox_escaping_scenarios',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'No Server Side Validation',
                name: 'no_server_side_validation',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Sensitive Data In Code',
                name: 'sensitive_data_in_code',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Xss Protection Bypass',
                name: 'xss_protection_bypass',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Cross Site Request Forgery',
                name: 'cross_site_request_forgery',
                count: 10,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Mind The Pipe Part 1',
                name: 'mind_the_pipe_part_1',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Stored Persistent Xss',
                name: 'stored_persistent_xss',
                count: 10,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Race Conditions P1',
                name: 'race_conditions_p1',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Null Pointer Dereference P1',
                name: 'null_pointer_dereference_p1',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Compiler Optimizations Bugs P1',
                name: 'compiler_optimizations_bugs_p1',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Dangerous Use Of Api P1',
                name: 'dangerous_use_of_api_p1',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'Clearing Memory P1',
                name: 'clearing_memory_p1',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Formatstring P3',
                name: 'c_formatstring_p3',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Formatstring P2',
                name: 'c_formatstring_p2',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Formatstring P1',
                name: 'c_formatstring_p1',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Integer P1',
                name: 'c_integer_p1',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Heap P1',
                name: 'c_heap_p1',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Stack P3',
                name: 'c_stack_p3',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Stack P2',
                name: 'c_stack_p2',
                count: 2,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Orientation',
                name: 'c_orientation',
                count: 1,
            },
            {
                id: 1,
                uuid: 'e843udjnjweode3ewqhoijw1',
                displayName: 'C Stack P1',
                name: 'c_stack_p1',
                count: 1,
            },
        ],
    },
];
